import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { formatCategory, formatDateShort } from '../../utils/formatters';

const ProjectCard = ({ project }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link
      to={`/portfolio/${project.slug}`}
      className="group block"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="bg-white rounded-lg overflow-hidden shadow-soft hover:shadow-hover transition-all duration-500 hover:-translate-y-2">
        {/* Image container with 3:4 aspect ratio */}
        <div className="relative overflow-hidden aspect-3/4 bg-bg-secondary">
          <img
            src={project.coverImage}
            alt={project.title}
            className={`w-full h-full object-cover transition-all duration-600 ${
              isHovered ? 'scale-105' : 'scale-100'
            }`}
            loading="lazy"
          />

          {/* Overlay on hover */}
          <div
            className={`absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent transition-opacity duration-500 ${
              isHovered ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform transition-transform duration-500">
              <p className="text-sm font-body mb-2 opacity-90">View Project</p>
              <div className="w-12 h-0.5 bg-white"></div>
            </div>
          </div>

          {/* Featured badge */}
          {project.featured && (
            <div className="absolute top-4 right-4 bg-accent text-white px-4 py-2 rounded-full text-sm font-body font-medium shadow-lg">
              Featured
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-6 lg:p-8">
          {/* Category and date */}
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm text-accent font-body font-semibold uppercase tracking-wider">
              {formatCategory(project.category)}
            </span>
            {project.date && (
              <span className="text-sm text-text-light font-body">
                {formatDateShort(project.date)}
              </span>
            )}
          </div>

          {/* Title */}
          <h3 className="text-2xl lg:text-h3 font-heading font-bold text-secondary mb-3 group-hover:text-accent transition-colors duration-400">
            {project.title}
          </h3>

          {/* Description */}
          <p className="text-text-secondary font-body leading-relaxed line-clamp-3 mb-4">
            {project.description}
          </p>

          {/* Client */}
          {project.clientName && (
            <p className="text-sm text-text-light font-body">
              <span className="font-medium">Client:</span> {project.clientName}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProjectCard;
